import CustomButton from "components/CustomButton";
import { useReducer } from "react";
import { companyCultureReducer } from "store/reducers/companyCultureReducer";
import { companyCultureState } from "store/reducers/companyCultureReducer";
import UploadModal from "./UploadModal/UploadModal";

const CompanyCulture = ({ activeTab, setReload, disabled }) => {
  const [{ addModal }, dispatch] = useReducer(
    companyCultureReducer,
    companyCultureState
  );

  const handleUploadModal = () => {
    dispatch({ type: "setAddModal", value: !addModal });
  };

  return (
    <div className="companyCultureWrapper">
      <div className={activeTab === 3 ? "addCompanyCultureDocument" : "addCompanyCultureVideo"}>
        <CustomButton onClick={handleUploadModal} disabled={disabled}>
          {activeTab === 3 ? "Upload Document" : "Upload Media"}
        </CustomButton>
      </div>

      {/* Upload modal */}
      {addModal && (
        <UploadModal
          activeTab={activeTab}
          onClose={handleUploadModal}
          setReload={setReload}
        />
      )}
    </div>
  );
};

export default CompanyCulture;
